import { render, staticRenderFns } from "./TeacherSection.vue?vue&type=template&id=87bd2786&scoped=true&"
import script from "./TeacherSection.vue?vue&type=script&lang=js&"
export * from "./TeacherSection.vue?vue&type=script&lang=js&"
import style0 from "./TeacherSection.vue?vue&type=style&index=0&id=87bd2786&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bd2786",
  null
  
)

export default component.exports